import { WritableSignal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { CommunityDTO } from 'src/app/DTO/CommunityDTO';

export const PRIOR_APPOINTMENT_PRE_RESERVATION_LABELS_PARAM =
  'PRIORAPPOINTMENT.PRE_RESERVATION_LABELS';

export const PRIOR_APPOINTMENT_PRE_APPOINTMENT_LABELS_PARAM =
  'PRIORAPPOINTMENT.PRE_APPOINTMENT_LABELS';

const PRE_RESERVATION_LABEL_PARAM_KEYS = [
  PRIOR_APPOINTMENT_PRE_RESERVATION_LABELS_PARAM,
  PRIOR_APPOINTMENT_PRE_APPOINTMENT_LABELS_PARAM,
] as const;

function parameterEntryKey(entry: { key?: string; Key?: string } | null | undefined): string {
  return String(entry?.key ?? entry?.Key ?? '').trim();
}

function parameterEntryValue(entry: { value?: string; Value?: string } | null | undefined): string | undefined {
  const raw = entry?.value ?? entry?.Value;
  return raw == null ? undefined : String(raw);
}

export function readPreReservationLabelsParam(
  parameters: { key?: string; value?: string; Key?: string; Value?: string }[] | null | undefined
): boolean {
  const list = parameters ?? [];
  const match = list.find((p) =>
    PRE_RESERVATION_LABEL_PARAM_KEYS.includes(parameterEntryKey(p) as (typeof PRE_RESERVATION_LABEL_PARAM_KEYS)[number])
  );
  const raw = parameterEntryValue(match);
  if (raw == null) {
    return false;
  }
  const v = raw.trim().toLowerCase();
  return v === 'true' || v === '1';
}

export function preAppointmentI18nKey(priorKey: string): string {
  if (!priorKey) {
    return priorKey;
  }
  const roots = [
    'PRIORAPPOINTMENTCOMPLETED',
    'PRIORAPPOINTMENTCREATE',
    'PRIORAPPOINTMENTDETAIL',
    'PRIORAPPOINTMENTFINISH',
    'PRIORAPPOINTMENT',
  ];
  for (const from of roots) {
    if (priorKey === from || priorKey.startsWith(`${from}.`)) {
      return 'PREAPPOINTMENT' + priorKey.slice('PRIORAPPOINTMENT'.length);
    }
  }
  return priorKey;
}

export async function loadPreReservationLabelsForModule(
  api: ApiService,
  community: CommunityDTO | null | undefined,
  communityModuleId: number | null | undefined,
  target: WritableSignal<boolean>,
  isActiveModule: () => number | null
): Promise<void> {
  target.set(false);
  if (!community?.id || communityModuleId == null) {
    console.log('[WT-7479 pre-reserva] skip load: missing community or moduleId', {
      communityId: community?.id,
      communityModuleId,
    });
    return;
  }
  const requestedId = communityModuleId;
  try {
    // Fetch by id (not list `/modules`): works for submodules and iframe embeds of `/m/:moduleId`.
    const module = await firstValueFrom(api.GetModuleById(community.id, requestedId).pipe(first()));
    if (isActiveModule() !== requestedId) {
      console.log('[WT-7479 pre-reserva] stale module response ignored', { requestedId });
      return;
    }
    const parameters = module?.parameters ?? [];
    const enabled = readPreReservationLabelsParam(parameters);
    const related = parameters
      .map((p) => ({ key: parameterEntryKey(p), value: parameterEntryValue(p) }))
      .filter((p) => p.key.includes('PRIORAPPOINTMENT') || p.key.includes('PRE_'));
    console.log('[WT-7479 pre-reserva] module loaded (portal)', {
      communityId: community.id,
      communityModuleId: requestedId,
      preReservationLabelsEnabled: enabled,
      expectedKeys: [...PRE_RESERVATION_LABEL_PARAM_KEYS],
      matchingParams: related,
      allParameterKeys: parameters.map((p) => parameterEntryKey(p)),
    });
    target.set(enabled);
  } catch (err) {
    console.warn('[WT-7479 pre-reserva] GetModuleById failed (portal)', {
      communityId: community.id,
      communityModuleId: requestedId,
      err,
    });
    if (isActiveModule() === requestedId) {
      target.set(false);
    }
  }
}
